import { render, staticRenderFns } from "./CategorySearch.vue?vue&type=template&id=117284ae&scoped=true&"
import script from "./CategorySearch.vue?vue&type=script&lang=js&"
export * from "./CategorySearch.vue?vue&type=script&lang=js&"
import style0 from "./CategorySearch.vue?vue&type=style&index=0&id=117284ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117284ae",
  null
  
)

export default component.exports